(() => {
    const
        D = window.document,
        clasPrefix = ".top-geo-ip__",
        geoContainer = document.querySelectorAll('.top-geo-ip'),
        desktopCheckbox = D.querySelector("#top-geo-ip-checkbox"),
        mobileCheckbox = D.querySelector("#mobile-geo-ip-checkbox"),
        mobileMenu = D.querySelector("#mobile-menu-checkbox"),
        address = D.querySelectorAll(clasPrefix + "address"),
        contentInfo = D.querySelectorAll(clasPrefix + "content-info"),
        submitZIPBtb = D.querySelectorAll(clasPrefix + "zip-btn"),
        zipInput = D.querySelectorAll(clasPrefix + "zip-input"),
        zipForm = D.querySelectorAll(clasPrefix + "zip-form"),
        zipChangeBlock = D.querySelectorAll(clasPrefix + "change"),
        zip = D.querySelectorAll(clasPrefix + "zip"),
        changeZipBtn = D.querySelectorAll(clasPrefix + "change-btn"),
        formTitle = D.querySelectorAll(clasPrefix + "content-subtitle--form"),
        emailForm = D.querySelectorAll(clasPrefix + "email-form"),
        emailFormTitle = D.querySelectorAll(clasPrefix + 'content-subtitle-email'),
        submitEmailBtb = D.querySelectorAll(clasPrefix + "email-btn"),
        emailInput = D.querySelectorAll(clasPrefix + "email-input"),
        thanks = D.querySelectorAll(clasPrefix + "content-thanks"),
        noDeliveryIcon = D.querySelectorAll(clasPrefix + "no-delivery"),
        triggerZipPopup = D.querySelector(".product__form-text a"),
        productPageBtnFake = D.querySelector('div.product-form__submit'),
        productPageBtn = D.querySelector('button.product-form__submit'),
        productPageNote = D.querySelector('.product__form-note'),
        productPage = D.querySelector('.product'),
        growingZone = D.querySelectorAll(clasPrefix + 'growing-zone'),
        messageAvailable = D.querySelectorAll(clasPrefix + 'request-message-available'),
        messageCA = D.querySelectorAll(clasPrefix + 'request-message-ca'),
        messageUnavailable = D.querySelectorAll(clasPrefix + "request-message-unavailable");

    const lsPrefix = "mtn-v0-2_";
    let email = "";
    let newRequest = false;
    let restart = false;
    let firstLoad = true;
    let emailTimeout;
    let closeWindow;

    if (triggerZipPopup) {
      triggerZipPopup.addEventListener('click', function () {
        if (desktopCheckbox) desktopCheckbox.checked = true;
        if (mobileCheckbox) mobileCheckbox.checked = true;
        window.scrollTo({ top: -1000, behavior: 'smooth' });

        if (window.screen.width <= 990) {
          mobileMenu.checked = true
          document.querySelector('#MainContent').classList.add('blur-effect')
          document.querySelector('html, body').classList.add('is-mob-open')
        }
      })
    }

    const init = () => {
        submitZIPBtb.forEach((btn, index) => {
            btn.index = index;
            btn.addEventListener("click", clickSubmitZIPBtnHandler);
        });

        emailInput.forEach((field) => {
            field.addEventListener("input", imputEmailHandler);
        });

        submitEmailBtb.forEach((btn, index) => {
            btn.addEventListener("click", clickSubmitEmailBtnHandler);
        });

        zipInput.forEach((input, index) => input.index = index);

        GeoAPI.on("update", update).load();

        changeZipBtn.forEach((btn) => {
            btn.addEventListener("click", () => {
                desktopCheckbox.checked = false;
                restart = true;
                update(true);
            });
        });

        setTimeout(() => {
            firstLoad = false;
        }, 1000);
    };

    const saveZipToCart = (zip) => {
      var formData = new FormData();
      formData.append("attributes[zip]", zip);
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json());
    }

    const update = () => {
        saveZipToCart(GeoAPI.zip);
        const localStorageGeo = localStorage.getItem(lsPrefix + "userGEO");
        const status = GeoAPI.currentStatus;
        const isGeoBlocked = status === GeoAPI.searchStatus.GEO_BLOCKED || status === GeoAPI.searchStatus.NO_COUNTRY_DELIVERY;
        const hasDelivery = status === GeoAPI.searchStatus.HAS_DELIVERY;
        const noDeliveryInTheUS = status === GeoAPI.searchStatus.NO_ZIP_DELIVERY || status === GeoAPI.searchStatus.NO_STATE_DELIVERY;
        clearTimeout(closeWindow);

        if (firstLoad) geoContainer.forEach(container => container.classList.remove('disabled'));

        messageAvailable.forEach((el) => el.classList.remove("is-active"));
        messageCA.forEach((el) => el.classList.remove("is-active"));
        messageUnavailable.forEach((el) => el.classList.remove("is-active"));
        zipChangeBlock.forEach((el) => el.classList.remove("is-active"));
        growingZone.forEach((el) => el.classList.remove("is-active"));
        emailForm.forEach((block) => (block.style.display = "none"));
        emailFormTitle.forEach((block) => (block.style.display = "none"));
        thanks.forEach((thanksBlock) => (thanksBlock.style.display = "none"));
        geoContainer.forEach(container => container.classList.remove('is-available'));

        if (!localStorageGeo || restart) {
            contentInfo.forEach((el) => el.classList.add("is-active"));
            zipForm.forEach((el) => el.classList.add("is-active"));
            formTitle.forEach((el) => el.classList.add("is-active"));
        } else {
            if (GeoAPI.zone) {
                growingZone.forEach(el => {
                    el.classList.add('is-active');
                    el.querySelector('span').innerText = getFormattedGrowingZone(GeoAPI.zone)
                });
            }

            if (hasDelivery) {
                geoContainer.forEach(container => container.classList.add('is-available'));
                messageAvailable.forEach(el => el.classList.add('is-active'))

                if (newRequest) {
                    desktopCheckbox.checked = true;
                    mobileCheckbox.checked = true;
                    closeWindow = setTimeout(() => {
                        desktopCheckbox.checked = false;
                        mobileCheckbox.checked = false;
                        geoContainer.forEach(container => container.classList.remove('is-active'));
                    }, 2000);
                }
            } else if (!hasDelivery && GeoAPI.stateAbbr === "CA") {
                messageCA.forEach(el => el.classList.add("is-active"))
            } else if (!hasDelivery) {
                messageUnavailable.forEach(el => el.classList.add("is-active"))
            }

            contentInfo.forEach((el) => el.classList.remove("is-active"));
            zipForm.forEach((el) => el.classList.remove("is-active"));
            formTitle.forEach((el) => el.classList.remove("is-active"));

            zipChangeBlock.forEach(el => el.classList.add('is-active'))
            zip.forEach((el) => (el.innerText = GeoAPI.zip));
        }
        
        setText(address, !hasDelivery ? "See if we deliver to you" : GeoAPI.city ? (capitalize(GeoAPI.city) + ", " + GeoAPI.stateAbbr + " " + GeoAPI.zip) : GeoAPI.zip);
        zipInput.forEach(input => input.value = "");
        noDeliveryIcon.forEach(icon => icon.style.display = noDeliveryInTheUS ? "flex" : "none");

        if (productPage) {
          productPageBtn.classList.remove('opacity');
          productPageNote.classList.add('product__form-note--hidden');
          productPageBtnFake.classList.add('opacity');
        }

        if (!hasDelivery && !restart) {
          switchToEmailForm(localStorageGeo);
        }

        newRequest = false;
        restart = false;
    };

    const switchToEmailForm = (locaStorage = false) => {
        if (locaStorage) {
            emailForm.forEach(block => block.style.display = "flex");
            emailFormTitle.forEach(block => block.style.display = "block");
            thanks.forEach(thanksBlock => thanksBlock.style.display = "none");
        }
    }

    const clickSubmitZIPBtnHandler = (e) => {
        const index = e.currentTarget.index;
        const zip = zipInput[index] ? zipInput[index].value : "";
        if (!!zip) {
            GeoAPI.findAreaByZip(zip);
            GmtData.trackGMTZipCode(zip);
        }

        newRequest = true;
        e.preventDefault();
    };

    const imputEmailHandler = (e) => {
        email = e.target.value;
        emailInput.forEach(field => field.classList.remove("wrong_email"));
    };

    const clickSubmitEmailBtnHandler = (e) => {
        e.preventDefault();
        clearTimeout(emailTimeout);

        if (/.+@.+\..+/i.test(email)) {
            fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    "cache-control": "no-cache"
                },
                body: new URLSearchParams({
                    "g": "WgiKSP",
                    "$fields": "$zip,$city",
                    "email": email,
                    "$zip": GeoAPI.zip,
                    "$city": GeoAPI.city
                }).toString()
            }).then(res => {
                if (res.status === 200) {
                    emailInput.forEach(el => el.value = '');
                    thanks.forEach(thanksBlock => thanksBlock.style.display = "block");

                    emailTimeout = setTimeout(() => {
                        thanks.forEach(thanksBlock => thanksBlock.style.display = "none");
                    }, 10000);
                }
                else
                    console.error("subscribing problem");
            }).catch(er => {
                console.error(er);
            });
        } else {
            emailInput.forEach(field => field.classList.add("wrong_email"));
        }
    }

    const getFormattedGrowingZone = (value) => {
        return typeof value === "string" ? value.split(",").join(", ").toUpperCase() : "";
    };

    const setText = (ar, value) => {
        for (let i = 0; i < ar.length; i ++)
            ar[i].innerHTML = value;
    };

    // UTILS //

    const capitalize = (words) => {
        const ar = words.split(" ");
        for (let i = 0; i < ar.length; i ++)
            ar[i] = ar[i].toLowerCase().replace(/\w/, firstLetter => firstLetter.toUpperCase());

        return ar.join(" ");
    };

    const traceResults = () => {
        console.log('%cGEO API TRACE', 'color: green; font-size:16px');
        console.log("Country: ", GeoAPI.country);
        console.log("State: ", GeoAPI.state);
        console.log("State Abbr: ", GeoAPI.stateAbbr);
        console.log("State Ok: ", GeoAPI.stateOk);
        console.log("City: ", GeoAPI.city);
        console.log("Zone: ", GeoAPI.zone);
        console.log("Zone Delivery: ", GeoAPI.zoneDelivery);
        console.log('%cSearch Status: ' +  GeoAPI.currentStatus, 'color: blue; font-size:12px');
        console.log('%c--------------', 'color: green; font-size:16px');
    };

    init();
})();


document.addEventListener("DOMContentLoaded", function () {
  const geoContainer = document.querySelectorAll(".top-geo-ip");
  let hoverTimer;

  geoContainer.forEach((container) => {
    container.addEventListener("mouseenter", function () {
      if (window.innerWidth >= 990) {
        clearTimeout(hoverTimer);
        container.classList.add("is-active");
      }
    });

    container.addEventListener("mouseleave", function () {
      if (window.innerWidth >= 990) {
        clearTimeout(hoverTimer);

        hoverTimer = setTimeout(() => {
          container.classList.remove("is-active");
        }, 200);
      }
    });
  });

  window.addEventListener("resize", function () {
    if (window.innerWidth < 990) {
      geoContainer.forEach((container) => {
        container.classList.remove("is-active");
      });
    }
  });
});